import { formOptions, gen } from '../../views/utils'

// const Client = Modal({
//   firstName: NAME,
//   lastName: NAME,
//   phone: PHONE,
//   invoiceName: STRING,
//   invoiceAddress: ADDRESS,
//   invoicePhone: PHONE,
//   invoiceEmail: EMAIL,
//   invoiceContactId: ID,
// })

export default {
  auto: '*',
  store: {
    actions: {
      CREATE_CLIENTS_WRAP({ dispatch }, { client, groupId, passId }) {
        dispatch('CREATE_CLIENTS', {
          groupId,
          ...client,
        }).then((savedClient) => {
          if (passId) {
            passId.clientId = savedClient.id
          }

          dispatch('SUCCESS', 'Client added')
        })
      },
    },
    getters: {
      genClient: gen(() => ({
        firstName: '',
        lastName: '',
        phone: '',
        invoiceName: '',
        invoiceAddress: '',
        invoicePhone: '',
        invoiceEmail: '',
        invoiceContactId: null,
      })),

      clientsOptions: formOptions({
        value: ({ firstName, lastName, phone }) => [`${firstName} ${lastName}`, phone],
      }),
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/clients.js